import { render } from "./input-number.vue?vue&type=template&id=8cc218ba"
import script from "./input-number.vue?vue&type=script&lang=js"
export * from "./input-number.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__